export default function () {
  return [
    {name: 'Ene', monto: 20},
    {name: 'Mar', monto: 21},
    {name: 'Abr', monto: 22},
    {name: 'May', monto: 23},
    {name: 'Jun', monto: 24},
    {name: 'Jul', monto: 25},
    {name: 'Ago', monto: 25},
    {name: 'Sep', monto: 26},
    {name: 'Oct', monto: 27},
    {name: 'Nov', monto: 26},
    {name: 'Dic', monto: 25},
  ]
};



// WEBPACK FOOTER //
// ./src/reducers/chart-reducers/amountPortfolio.js